exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.filter-bar[data-v-3eab207c] {\n    padding: 0px;\n}\n", ""]);

// exports
